// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.VerifyEmailAlert_email-alert__lTrkL {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background-color: rgba(12, 36, 28, 0.4);
  backdrop-filter: blur(4px);
  z-index: 9999;
  font-family: "Sora", sans-serif;
  animation: VerifyEmailAlert_fadeIn__6rEZs 0.3s ease;
  padding: 24px;
}
.VerifyEmailAlert_email-alert__card__1xxfc {
  background-color: #F7F5F1;
  padding: 24px;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(16, 25, 21, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 400px;
  animation: VerifyEmailAlert_slideInUp__0o4gS 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
.VerifyEmailAlert_email-alert__header__5szT9 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;
}
.VerifyEmailAlert_email-alert__icon-box__GiQ\\+4 {
  width: 44px;
  height: 44px;
  background: rgba(214, 166, 64, 0.1);
  color: #D6A640;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  border: 1px solid rgba(214, 166, 64, 0.2);
}
.VerifyEmailAlert_email-alert__title-group__7ne6m {
  flex: 1 1;
  text-align: left;
}
.VerifyEmailAlert_email-alert__eyebrow__0Vn2r {
  display: block;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #82B194;
  margin-bottom: 2px;
}
.VerifyEmailAlert_email-alert__title__L9HD9 {
  font-size: 17px;
  font-weight: 800;
  color: #13231D;
  margin: 0;
  letter-spacing: -0.02em;
}
.VerifyEmailAlert_email-alert__close-btn__jBfVu {
  position: absolute;
  top: -4px;
  right: -4px;
  background: transparent;
  border: none;
  color: #5F726B;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  opacity: 0.5;
  transition: all 0.2s;
}
.VerifyEmailAlert_email-alert__close-btn__jBfVu:hover {
  opacity: 1;
  background-color: #F3F5F2;
  color: #13231D;
}
.VerifyEmailAlert_email-alert__body__ulNH8 {
  text-align: left;
}
.VerifyEmailAlert_email-alert__text__2H0wX {
  font-size: 14px;
  color: #5F726B;
  line-height: 1.5;
  margin: 0 0 12px;
  font-weight: 500;
}
.VerifyEmailAlert_email-alert__info-box__AQPQD {
  background-color: #F8F6F2;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 12px;
  color: #5F726B;
  border: 1px solid rgba(16, 25, 21, 0.04);
  box-shadow: 0 2px 4px rgba(16, 25, 21, 0.02);
}
.VerifyEmailAlert_email-alert__info-box__AQPQD span {
  display: block;
  margin-bottom: 2px;
  opacity: 0.7;
}
.VerifyEmailAlert_email-alert__info-box__AQPQD strong {
  color: #13231D;
  font-weight: 700;
  word-break: break-all;
}
.VerifyEmailAlert_email-alert__actions__7AUJu {
  width: 100%;
  margin-top: 4px;
}

@keyframes VerifyEmailAlert_slideInUp__0o4gS {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 992px) {
  .VerifyEmailAlert_email-alert__lTrkL {
    bottom: 20px;
    left: 20px;
    max-width: 380px;
  }
  .VerifyEmailAlert_email-alert__card__1xxfc {
    padding: 20px;
  }
}
@media (max-width: 768px) {
  .VerifyEmailAlert_email-alert__lTrkL {
    left: 16px;
    right: 16px;
    bottom: 16px;
    max-width: none;
    width: auto;
  }
  .VerifyEmailAlert_email-alert__card__1xxfc {
    padding: 18px;
    gap: 12px;
  }
  .VerifyEmailAlert_email-alert__icon-box__GiQ\\+4 {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }
  .VerifyEmailAlert_email-alert__icon-box__GiQ\\+4 svg {
    font-size: 20px !important;
  }
  .VerifyEmailAlert_email-alert__title__L9HD9 {
    font-size: 16px;
  }
  .VerifyEmailAlert_email-alert__eyebrow__0Vn2r {
    font-size: 9px;
  }
  .VerifyEmailAlert_email-alert__body__ulNH8 {
    gap: 10px;
  }
  .VerifyEmailAlert_email-alert__text__2H0wX {
    font-size: 13px;
    margin-bottom: 8px;
  }
  .VerifyEmailAlert_email-alert__info-box__AQPQD {
    padding: 8px 12px;
    font-size: 11px;
  }
  .VerifyEmailAlert_email-alert__actions__7AUJu {
    margin-top: 0;
  }
}
@media (max-width: 576px) {
  .VerifyEmailAlert_email-alert__lTrkL {
    padding: 16px;
  }
  .VerifyEmailAlert_email-alert__card__1xxfc {
    padding: 16px;
  }
}
@keyframes VerifyEmailAlert_fadeIn__6rEZs {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(4px);
  }
}
@keyframes VerifyEmailAlert_slideInUp__0o4gS {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ui/VerifyEmailAlert/VerifyEmailAlert.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AANA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,0BAAA;EACA,aAAA;EACA,+BAAA;EACA,mDAAA;EACA,aAAA;AASF;AAPE;EACE,yBDJmB;ECKnB,aAAA;EACA,mBDyBY;ECxBZ,2CDwCU;ECvCV,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,+EAAA;AASJ;AANE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAQJ;AALE;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,cDjCmB;ECkCnB,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,yCAAA;AAOJ;AAJE;EACE,SAAA;EACA,gBAAA;AAMJ;AAHE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDvDmB;ECwDnB,kBAAA;AAKJ;AAFE;EACE,eAAA;EACA,gBAAA;EACA,cDjDmB;ECkDnB,SAAA;EACA,uBAAA;AAIJ;AADE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,cD3DmB;EC4DnB,eAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AAGJ;AADI;EACE,UAAA;EACA,yBAAA;EACA,cDtEiB;ACyEvB;AACE;EACE,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,cD/EmB;ECgFnB,gBAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,yBD3FmB;EC4FnB,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cD1FmB;EC2FnB,wCAAA;EACA,4CAAA;AADJ;AAGI;EAAO,cAAA;EAAgB,kBAAA;EAAoB,YAAA;AAE/C;AADI;EAAS,cDhGU;ECgGO,gBAAA;EAAkB,qBAAA;AAMhD;AAHE;EACE,WAAA;EACA,eAAA;AAKJ;;AADA;EACE;IACE,UAAA;IACA,uCAAA;EAIF;EAFA;IACE,UAAA;IACA,iCAAA;EAIF;AACF;AADA;EACE;IACE,YAAA;IACA,UAAA;IACA,gBAAA;EAGF;EADE;IACE,aAAA;EAGJ;AACF;AACA;EACE;IACE,UAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,WAAA;EACF;EACE;IACE,aAAA;IACA,SAAA;EACJ;EAEE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EAAJ;EAEI;IACE,0BAAA;EAAN;EAIE;IACE,eAAA;EAFJ;EAKE;IACE,cAAA;EAHJ;EAME;IACE,SAAA;EAJJ;EAOE;IACE,eAAA;IACA,kBAAA;EALJ;EAQE;IACE,iBAAA;IACA,eAAA;EANJ;EASE;IACE,aAAA;EAPJ;AACF;AAWA;EACE;IACE,aAAA;EATF;EAWE;IACE,aAAA;EATJ;AACF;AAaA;EACE;IACE,UAAA;IACA,0BAAA;EAXF;EAaA;IACE,UAAA;IACA,0BAAA;EAXF;AACF;AAcA;EACE;IACE,UAAA;IACA,2BAAA;EAZF;EAcA;IACE,UAAA;IACA,wBAAA;EAZF;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-gold: $color-gold;\n$bw-text: $text-main;\n$bw-muted: $text-muted;\n$bw-border: $color-border;\n$bw-radius-xl: $radius-xl;\n$bw-shadow-float: $shadow-card;\n\n.email-alert {\n  position: fixed;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  background-color: rgba(12, 36, 28, 0.4);\n  backdrop-filter: blur(4px);\n  z-index: 9999;\n  font-family: \"Sora\", sans-serif;\n  animation: fadeIn 0.3s ease;\n  padding: 24px;\n\n  &__card {\n    background-color: $color-surface;\n    padding: 24px;\n    border-radius: $bw-radius-xl;\n    box-shadow: $bw-shadow-float;\n    border: 1px solid $bw-border;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    max-width: 400px;\n    animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    position: relative;\n  }\n\n  &__icon-box {\n    width: 44px;\n    height: 44px;\n    background: rgba($bw-gold, 0.1);\n    color: $bw-gold;\n    border-radius: 12px;\n    display: grid;\n    place-items: center;\n    flex-shrink: 0;\n    border: 1px solid rgba($bw-gold, 0.2);\n  }\n\n  &__title-group {\n    flex: 1;\n    text-align: left;\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: 10px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    color: $bw-primary;\n    margin-bottom: 2px;\n  }\n\n  &__title {\n    font-size: 17px;\n    font-weight: 800;\n    color: $bw-text;\n    margin: 0;\n    letter-spacing: -0.02em;\n  }\n\n  &__close-btn {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    background: transparent;\n    border: none;\n    color: $bw-muted;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 50%;\n    opacity: 0.5;\n    transition: all 0.2s;\n\n    &:hover {\n      opacity: 1;\n      background-color: #F3F5F2;\n      color: $bw-text;\n    }\n  }\n\n  &__body {\n    text-align: left;\n  }\n\n  &__text {\n    font-size: 14px;\n    color: $bw-muted;\n    line-height: 1.5;\n    margin: 0 0 12px;\n    font-weight: 500;\n  }\n\n  &__info-box {\n    background-color: $color-surface-soft;\n    padding: 10px 14px;\n    border-radius: 12px;\n    font-size: 12px;\n    color: $bw-muted;\n    border: 1px solid rgba(16, 25, 21, 0.04);\n    box-shadow: 0 2px 4px rgba(16, 25, 21, 0.02);\n\n    span { display: block; margin-bottom: 2px; opacity: 0.7; }\n    strong { color: $bw-text; font-weight: 700; word-break: break-all; }\n  }\n\n  &__actions {\n    width: 100%;\n    margin-top: 4px;\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: $breakpoint-lg) {\n  .email-alert {\n    bottom: 20px;\n    left: 20px;\n    max-width: 380px;\n\n    &__card {\n      padding: 20px;\n    }\n  }\n}\n\n@media (max-width: $breakpoint-md) {\n  .email-alert {\n    left: 16px;\n    right: 16px;\n    bottom: 16px;\n    max-width: none;\n    width: auto;\n\n    &__card {\n      padding: 18px;\n      gap: 12px;\n    }\n\n    &__icon-box {\n      width: 40px;\n      height: 40px;\n      border-radius: 10px;\n      \n      svg {\n        font-size: 20px !important;\n      }\n    }\n\n    &__title {\n      font-size: 16px;\n    }\n\n    &__eyebrow {\n      font-size: 9px;\n    }\n\n    &__body {\n      gap: 10px;\n    }\n\n    &__text {\n      font-size: 13px;\n      margin-bottom: 8px;\n    }\n\n    &__info-box {\n      padding: 8px 12px;\n      font-size: 11px;\n    }\n\n    &__actions {\n      margin-top: 0;\n    }\n  }\n}\n\n@media (max-width: $breakpoint-sm) {\n  .email-alert {\n    padding: 16px;\n\n    &__card {\n      padding: 16px;\n    }\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n  to {\n    opacity: 1;\n    backdrop-filter: blur(4px);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"email-alert": `VerifyEmailAlert_email-alert__lTrkL`,
	"fadeIn": `VerifyEmailAlert_fadeIn__6rEZs`,
	"email-alert__card": `VerifyEmailAlert_email-alert__card__1xxfc`,
	"slideInUp": `VerifyEmailAlert_slideInUp__0o4gS`,
	"email-alert__header": `VerifyEmailAlert_email-alert__header__5szT9`,
	"email-alert__icon-box": `VerifyEmailAlert_email-alert__icon-box__GiQ+4`,
	"email-alert__title-group": `VerifyEmailAlert_email-alert__title-group__7ne6m`,
	"email-alert__eyebrow": `VerifyEmailAlert_email-alert__eyebrow__0Vn2r`,
	"email-alert__title": `VerifyEmailAlert_email-alert__title__L9HD9`,
	"email-alert__close-btn": `VerifyEmailAlert_email-alert__close-btn__jBfVu`,
	"email-alert__body": `VerifyEmailAlert_email-alert__body__ulNH8`,
	"email-alert__text": `VerifyEmailAlert_email-alert__text__2H0wX`,
	"email-alert__info-box": `VerifyEmailAlert_email-alert__info-box__AQPQD`,
	"email-alert__actions": `VerifyEmailAlert_email-alert__actions__7AUJu`
};
export default ___CSS_LOADER_EXPORT___;
